import React from 'react';
import {useSelector} from 'react-redux';
import * as alertsConsoleSelectors from 'alerts.console/store/selectors';
import Checkbox from 'common/componentsV2/Checkbox';

type PropTypes = {
  setQueryParams: Function,
  // Connect
  // TODO Yoav: check how to validate Props with useSelector.
  // queryParams: Object,
};

export default function FeedbackNegativeFilter(props: PropTypes) {
  // Connect
  const queryParams = useSelector((state) => alertsConsoleSelectors.getQueryParamsViews(state));

  const {negativeFeedback} = queryParams;

  const toggleFilter = (checked) => {
    const {setQueryParams} = props;

    setQueryParams({negativeFeedback: checked || undefined});
  };

  return (
    <div>
      <Checkbox isChecked={negativeFeedback} text="Marked as “Not Interesting”" onChange={toggleFilter} />
      <i className="icon icn-general24-dislike" style={{color: '#8995a0', fontSize: '16px', marginLeft: '5px'}} />
    </div>
  );
}
